<template>
    <div>
        <vs-popup
                class="notification-modal"
                title="Verstuur Notificatie"
                :active.sync="showPopup"
        >
            <div class="vx-row">
                <div class="vx-col w-full mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Titel"
                                v-model="title"
                        />
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <vs-select v-model="options.os" id="deliverer-area" class="w-full" label="Besturingssysteem">
                                <vs-select-item
                                        v-for="(item) in osOptions"
                                        :key="item.value"
                                        :value="item.value"
                                        :text="item.name"
                                />
                            </vs-select>
                        </div>
                        <div class="vx-col w-1/2">

                            <vs-select v-model="options.active" class="w-full" label="Bezorger type">
                                <vs-select-item
                                        v-for="(item) in delivererOptions"
                                        :key="item.value"
                                        :value="item.value"
                                        :text="item.name"
                                />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-select v-model="options.area" class="w-full" label="Gebied">
                                <vs-select-item
                                        v-for="(item) in areas"
                                        :key="item.value"
                                        :value="item.value"
                                        :text="item.name"
                                />
                            </vs-select>
                        </div>
                    </div>
                    <br>
                    <div class="vx-row">
                        <div class="vx-col w-full">

                    <vs-textarea
                            placeholder="Schrijf hier jouw notificatie, maximaal 160 karakters!"
                            v-model="message"
                            rows="10"
                            cols="8"
                            label="Content"
                            maxlength="160"
                    >
                    </vs-textarea>
                        </div>
                    </div>
                </div>
            </div>

            <vs-button class="mr-3 w-full mb-2 vs-con-loading__container" ref="loadableButton" id="send-global-notification" @click="sendNotification" :disabled="send">Verstuur notificatie
            </vs-button>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showPopup: false,
                massActive: false,
                loading: false,
                message: "",
                title: "",
                osOptions: [
                    {
                        "name": "Iedereen",
                        "value": "all"
                    },
                    {
                        "name": "iOS",
                        "value": "ios"
                    },
                    {
                        "name": "Android",
                        "value": "android"
                    }
                ],
                delivererOptions: [
                    {
                        "name": "Iedereen",
                        "value": "all"
                    },
                    {
                        "name": "Actief",
                        "value": "active"
                    },
                    {
                        "name": "Niet actief",
                        "value": "unactive"
                    }
                ],
                areas: [
                    {
                        "name": "Spijkenisse",
                        "value": "Spijkenisse"
                    },
                    {
                        "name": "Ijsselmonde",
                        "value": "Ijsselmonde"
                    },
                    {
                        "name": "Schiedam",
                        "value": "Schiedam"
                    },
                    {
                        "name": "Delft",
                        "value": "Delft"
                    },
                    {
                        "name": "Overal",
                        "value": "everyone"
                    },
                ],
                options: {
                    os: "all",
                    active: "all",
                    area: "Spijkenisse",
                }
            };
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen("open-notification-modal", () => {
                this.showPopup = true;
            });
        },
        computed: {
            send() {
                return this.title === "" || this.message === "" || this.loading;
            }
        },
        methods: {
            sendNotification() {
                let data = new FormData();
                data.append('title', this.title);
                data.append('message', this.message);
                data.append('options', JSON.stringify(this.options));
                this.$util.loading('#send-global-notification', this.$vs)
                this.loading = true;
                this.$http
                    .post('https://api.staging.hebtrek.nl/staff/notification/send', data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.loading = true;
                        this.$vs.loading.close('#send-global-notification > .con-vs-loading');
                        if (!silent) {
                            this.$vs.notify({
                                title: "Gelukt!",
                                text: "Iedereen heeft nu een melding ontvangen",
                                color: "green",
                                position: "top-center",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                      this.$vs.loading.close('#send-global-notification > .con-vs-loading');
                      this.loading = false
                      this.send = false;

                    });
            },
        }
    };
</script>
<style>
    ::placeholder {
        font-size: 0.9em;
    }
</style>